'use strict';

/**
 * homestage decorator implementation for the link module.
 *
 * @author Jan Widmer <jan.widmer@namics.com>
 */
T.Module.Link.HomeStage = T.createDecorator({
	start: function start(resolve) {
		this.$ctx = $(this._ctx);

		// Component Event Binding
		this.$ctx.on('click', this.onJumpToContentClick.bind(this));

		this._parent.start(resolve);
	},


	/**
  *  Event when the user clicks on the jump to content link
  *
  * @param {MouseEvent} ev - click event
  * @returns {void}
  */
	onJumpToContentClick: function onJumpToContentClick(ev) {
		ev.preventDefault();

		$('html,body').animate({
			scrollTop: $('#main-content').offset().top
		}, 'slow');
	}
});